class ProductOrder {
    getProductOrderUserRoles() {
        return ['admin', 'production_staff']
    }
    getProductOrderUserEmails() {
        return ['dk@production.befeni.net', 'mh@production.befeni.net', 'hl@production.befeni.net']
    }
}

let app = new ProductOrder;
export default app;
